import {
  getSubtractedDate,
  getTodayInTimezone,
} from '@spaced-out/ui-design-system/lib/utils';

import type {DateRange} from 'src/types/byod';

/**
 * The builder's canonical default date window: the last 7 days (today and the 6
 * prior days), in the given timezone. Used by the builder's date hook
 * (`useByodDateRange`) as the date picker's starting range. The embeddable view
 * has NO default — it requires an explicit host-provided window — so this is a
 * builder-only concern.
 *
 * Falls back to `'UTC'` when no timezone is supplied (the agency timezone can be
 * empty before agency data loads) — so the returned `timezone` is always an
 * explicit, resolved zone rather than an empty string passed downstream.
 */
export function getByodDefaultDateRange(timezone?: string): DateRange {
  const tz = timezone || 'UTC';
  const today = getTodayInTimezone(tz);
  return {
    startDate: getSubtractedDate(today, 6, 'd'),
    endDate: today,
    timezone: tz,
  };
}
